const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgSatisfactionSurvey(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    viewBox: "0 0 500 500",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "freepik--clip-path--inject-3"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M391,183.89c-4.62.54-16.59,8.7-17.41,9.52s-4.08,2.72-5.44,3.81c0,0-28,17.41-30.47,19s-7.34,4.9-7.07,6-14.42,25-14.42,25-4.35,5.72-.27,10.88,7.89,1.64,9.79.55,16.87-15.24,16.87-15.24l13.8,33s19.11-12.81,39.52-12l-13.61-53.32s18.78-14.14,19.32-19S395.65,183.34,391,183.89Z",
    style: {
      fill: "#fff",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }))), /*#__PURE__*/React.createElement("g", {
    id: "freepik--background-simple--inject-3"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M415.83,230.1a201.81,201.81,0,0,0-33.63-95.78c-30.74-45.45-80.91-70-135.49-56.62C195.1,90.36,182,146.24,139,171c-33,19-83,50-75,105,2.61,17.93,14.48,31,30.76,38.37,22.26,10.05,53.39,6,73.24,20.63,23,17,42,41,92,59,39.55,14.24,84.15-2.8,114-29.75C410.82,331.08,420,277.59,415.83,230.1Z",
    style: {
      fill: "#28BEA5"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M415.83,230.1a201.81,201.81,0,0,0-33.63-95.78c-30.74-45.45-80.91-70-135.49-56.62C195.1,90.36,182,146.24,139,171c-33,19-83,50-75,105,2.61,17.93,14.48,31,30.76,38.37,22.26,10.05,53.39,6,73.24,20.63,23,17,42,41,92,59,39.55,14.24,84.15-2.8,114-29.75C410.82,331.08,420,277.59,415.83,230.1Z",
    style: {
      fill: "#fff",
      opacity: 0.7000000000000001
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "freepik--Shadow--inject-3"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M430.44,410.52l-6.8-6.72c5.66-8.2,3.22-14.24-1.64-19.8-2.93-3.35-10.59-2.84-20-1.63L350,331l-8,3s21.64,26.35,41.91,50.58c-8.42.75-16.89.76-23.91-1.58-21-7-38-22-38-22-24,2,12,41,26,52,28,22,42.88,18,62.76,3.18,3.57,4.08,6.15,6.89,7.24,7.82l.21.18C427.17,431.62,438.72,418.71,430.44,410.52Z",
    style: {
      fill: "#28BEA5"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M430.44,410.52l-6.8-6.72c5.66-8.2,3.22-14.24-1.64-19.8-2.93-3.35-10.59-2.84-20-1.63L350,331l-8,3s21.64,26.35,41.91,50.58c-8.42.75-16.89.76-23.91-1.58-21-7-38-22-38-22-24,2,11.24,42.05,26,52,33,22.22,42.88,18,62.76,3.18,3.57,4.08,6.15,6.89,7.24,7.82l.21.18C427.17,431.62,438.72,418.71,430.44,410.52Z",
    style: {
      fill: "#fff",
      opacity: 0.5
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "freepik--Checklist--inject-3"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M377.2,329.43,228.65,371.24a7.77,7.77,0,0,1-8.49-3.5L107.51,165a4.41,4.41,0,0,1,2.83-6.68l148.55-41.81a7.75,7.75,0,0,1,8.48,3.49L380,322.74A4.42,4.42,0,0,1,377.2,329.43Z",
    style: {
      fill: "#263238",
      stroke: "#000",
      strokeMiterlimit: 10
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M226.56,362.35s85.84-20.42,143.62-40.43Z",
    style: {
      fill: "#884849"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "370.18 321.92 226.56 362.35 115.47 162.43 259.09 122.01 370.18 321.92",
    style: {
      fill: "#fff",
      stroke: "#263238",
      strokeMiterlimit: 10
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 216.55,
    y1: 164.35,
    x2: 227.7,
    y2: 161.21,
    style: {
      fill: "#fff",
      stroke: "#263238",
      strokeMiterlimit: 10
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 139.21,
    y1: 186.12,
    x2: 207.92,
    y2: 166.78,
    style: {
      fill: "#fff",
      stroke: "#263238",
      strokeMiterlimit: 10
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 204.32,
    y1: 176.77,
    x2: 232.02,
    y2: 168.97,
    style: {
      fill: "#fff",
      stroke: "#263238",
      strokeMiterlimit: 10
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 161.87,
    y1: 188.72,
    x2: 196.76,
    y2: 178.9,
    style: {
      fill: "#fff",
      stroke: "#263238",
      strokeMiterlimit: 10
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 143.52,
    y1: 193.88,
    x2: 155.39,
    y2: 190.54,
    style: {
      fill: "#fff",
      stroke: "#263238",
      strokeMiterlimit: 10
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 182.37,
    y1: 191.93,
    x2: 236.34,
    y2: 176.74,
    style: {
      fill: "#fff",
      stroke: "#263238",
      strokeMiterlimit: 10
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 147.84,
    y1: 201.65,
    x2: 170.5,
    y2: 195.27,
    style: {
      fill: "#fff",
      stroke: "#263238",
      strokeMiterlimit: 10
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M266.56,158.5a12.85,12.85,0,0,0-14-5.78c-5.17,1.46-7.26,6.4-4.68,11.05a12.82,12.82,0,0,0,14,5.78C267,168.1,269.14,163.15,266.56,158.5Z",
    style: {
      fill: "#fff",
      stroke: "#263238",
      strokeMiterlimit: 10
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 169.6,
    y1: 217.6,
    x2: 158.45,
    y2: 220.74,
    style: {
      fill: "#fff",
      stroke: "#263238",
      strokeMiterlimit: 10
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 246.94,
    y1: 195.83,
    x2: 178.23,
    y2: 215.17,
    style: {
      fill: "#fff",
      stroke: "#263238",
      strokeMiterlimit: 10
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 190.46,
    y1: 220.71,
    x2: 162.76,
    y2: 228.51,
    style: {
      fill: "#fff",
      stroke: "#263238",
      strokeMiterlimit: 10
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 232.91,
    y1: 208.76,
    x2: 198.02,
    y2: 218.58,
    style: {
      fill: "#fff",
      stroke: "#263238",
      strokeMiterlimit: 10
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 251.26,
    y1: 203.6,
    x2: 239.39,
    y2: 206.94,
    style: {
      fill: "#fff",
      stroke: "#263238",
      strokeMiterlimit: 10
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 221.04,
    y1: 221.08,
    x2: 167.08,
    y2: 236.27,
    style: {
      fill: "#fff",
      stroke: "#263238",
      strokeMiterlimit: 10
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 255.58,
    y1: 211.36,
    x2: 232.91,
    y2: 217.74,
    style: {
      fill: "#fff",
      stroke: "#263238",
      strokeMiterlimit: 10
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M285.8,193.13a12.82,12.82,0,0,0-14-5.78c-5.17,1.45-7.26,6.4-4.68,11a12.81,12.81,0,0,0,14,5.78C286.28,202.72,288.38,197.77,285.8,193.13Z",
    style: {
      fill: "#fff",
      stroke: "#263238",
      strokeMiterlimit: 10
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 255.03,
    y1: 233.59,
    x2: 266.18,
    y2: 230.45,
    style: {
      fill: "#fff",
      stroke: "#263238",
      strokeMiterlimit: 10
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 177.69,
    y1: 255.36,
    x2: 246.4,
    y2: 236.02,
    style: {
      fill: "#fff",
      stroke: "#263238",
      strokeMiterlimit: 10
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 242.8,
    y1: 246.02,
    x2: 270.5,
    y2: 238.22,
    style: {
      fill: "#fff",
      stroke: "#263238",
      strokeMiterlimit: 10
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 200.35,
    y1: 257.97,
    x2: 235.24,
    y2: 248.14,
    style: {
      fill: "#fff",
      stroke: "#263238",
      strokeMiterlimit: 10
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 182,
    y1: 263.13,
    x2: 193.87,
    y2: 259.79,
    style: {
      fill: "#fff",
      stroke: "#263238",
      strokeMiterlimit: 10
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 220.85,
    y1: 261.17,
    x2: 274.81,
    y2: 245.99,
    style: {
      fill: "#fff",
      stroke: "#263238",
      strokeMiterlimit: 10
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 186.32,
    y1: 270.9,
    x2: 208.98,
    y2: 264.52,
    style: {
      fill: "#fff",
      stroke: "#263238",
      strokeMiterlimit: 10
    }
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 295.68,
    cy: 230.38,
    rx: 8.48,
    ry: 10.73,
    transform: "translate(-26.91 421.27) rotate(-68.54)",
    style: {
      fill: "#fff",
      stroke: "#263238",
      strokeMiterlimit: 10
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 208.08,
    y1: 286.85,
    x2: 196.93,
    y2: 289.99,
    style: {
      fill: "#fff",
      stroke: "#263238",
      strokeMiterlimit: 10
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 285.42,
    y1: 265.08,
    x2: 216.71,
    y2: 284.42,
    style: {
      fill: "#fff",
      stroke: "#263238",
      strokeMiterlimit: 10
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 228.94,
    y1: 289.96,
    x2: 201.24,
    y2: 297.75,
    style: {
      fill: "#fff",
      stroke: "#263238",
      strokeMiterlimit: 10
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 271.39,
    y1: 278.01,
    x2: 236.5,
    y2: 287.83,
    style: {
      fill: "#fff",
      stroke: "#263238",
      strokeMiterlimit: 10
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 289.74,
    y1: 272.84,
    x2: 277.87,
    y2: 276.18,
    style: {
      fill: "#fff",
      stroke: "#263238",
      strokeMiterlimit: 10
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 259.52,
    y1: 290.33,
    x2: 205.56,
    y2: 305.52,
    style: {
      fill: "#fff",
      stroke: "#263238",
      strokeMiterlimit: 10
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 294.05,
    y1: 280.61,
    x2: 271.39,
    y2: 286.99,
    style: {
      fill: "#fff",
      stroke: "#263238",
      strokeMiterlimit: 10
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M324.27,262.37a12.83,12.83,0,0,0-14-5.78c-5.17,1.46-7.26,6.4-4.68,11.05a12.82,12.82,0,0,0,14,5.78C324.76,272,326.86,267,324.27,262.37Z",
    style: {
      fill: "#fff",
      stroke: "#263238",
      strokeMiterlimit: 10
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 293.51,
    y1: 302.84,
    x2: 304.66,
    y2: 299.7,
    style: {
      fill: "#fff",
      stroke: "#263238",
      strokeMiterlimit: 10
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 216.17,
    y1: 324.61,
    x2: 284.88,
    y2: 305.27,
    style: {
      fill: "#fff",
      stroke: "#263238",
      strokeMiterlimit: 10
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 281.28,
    y1: 315.26,
    x2: 308.98,
    y2: 307.47,
    style: {
      fill: "#fff",
      stroke: "#263238",
      strokeMiterlimit: 10
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 238.83,
    y1: 327.21,
    x2: 273.72,
    y2: 317.39,
    style: {
      fill: "#fff",
      stroke: "#263238",
      strokeMiterlimit: 10
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 220.48,
    y1: 332.38,
    x2: 232.35,
    y2: 329.03,
    style: {
      fill: "#fff",
      stroke: "#263238",
      strokeMiterlimit: 10
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 259.33,
    y1: 330.42,
    x2: 313.29,
    y2: 315.23,
    style: {
      fill: "#fff",
      stroke: "#263238",
      strokeMiterlimit: 10
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 224.8,
    y1: 340.14,
    x2: 247.46,
    y2: 333.76,
    style: {
      fill: "#fff",
      stroke: "#263238",
      strokeMiterlimit: 10
    }
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 334.16,
    cy: 299.63,
    rx: 8.48,
    ry: 10.73,
    transform: "translate(-66.96 500.99) rotate(-68.54)",
    style: {
      fill: "#fff",
      stroke: "#263238",
      strokeMiterlimit: 10
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M210.47,125.4l-18.88,5.31c-1.43.06-3-.05-3.44-.78-1-1.88.28-3.64.68-5.3A7.6,7.6,0,0,0,188,119a13.17,13.17,0,0,0-14.39-5.93c-5.3,1.5-7.44,6.57-4.8,11.33a12.41,12.41,0,0,0,5.56,5s3.83,1.71,4.6,3.09c.41.73-.66,1.59-1.75,2.24l-20.35,5.73a4.86,4.86,0,0,0-3.11,7.35l2.75,4.94,66.07-18.59-2.75-4.95A8.53,8.53,0,0,0,210.47,125.4Zm-33.63-6.46a4.21,4.21,0,0,1,4.61,1.9,2.39,2.39,0,0,1-1.54,3.62,4.2,4.2,0,0,1-4.6-1.89A2.4,2.4,0,0,1,176.84,118.94Z",
    style: {
      fill: "#28BEA5",
      stroke: "#263238",
      strokeMiterlimit: 10
    }
  }), /*#__PURE__*/React.createElement("polyline", {
    points: "251.21 159.08 259.36 164.77 267.76 145.94",
    style: {
      fill: "none",
      stroke: "#28BEA5",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: 6
    }
  }), /*#__PURE__*/React.createElement("polyline", {
    points: "270.15 193.17 278.3 198.85 286.7 180.03",
    style: {
      fill: "none",
      stroke: "#28BEA5",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: 6
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "freepik--Character--inject-3"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M403.82,188.51s2.17-4.62.81-8.16-26.39-9.25-26.39-9.25-5.71,0-5.44,3.27,20.95,15.78,22.58,16.86S403.27,194.77,403.82,188.51Z",
    style: {
      fill: "#fff",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M380.31,166.53a49.21,49.21,0,0,1-4.53-1.94c-2.16-1.08.21,3.89,1.08,4.1s3,.65,3,.65Z",
    style: {
      fill: "#fff",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M305.61,214.9,293.1,230.13l1.08,2.18L311.87,228l124.51-72.48a10.79,10.79,0,0,0,3.72-15h0a10.78,10.78,0,0,0-15-3.33Z",
    style: {
      fill: "#28BEA5",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 368.17,
    y1: 186.67,
    x2: 364.11,
    y2: 189.29,
    style: {
      fill: "#fff",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 403.12,
    y1: 164.19,
    x2: 373.13,
    y2: 183.49,
    style: {
      fill: "#fff",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M294.26,229.81s-3.11,1.3-2.63,2.61,4.94-1.86,4.94-1.86Z",
    style: {
      fill: "#28BEA5",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M293.1,230.13l1.08,2.18L311.87,228c-9.8-3.81-6.26-13.06-6.26-13.06Z",
    style: {
      fill: "#fff",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M440.1,140.45a10.78,10.78,0,0,0-15-3.33l-21.72,14.14a12.73,12.73,0,0,0-.88,4.68,12.15,12.15,0,0,0,11.85,12.38l22.07-12.84A10.79,10.79,0,0,0,440.1,140.45Z",
    style: {
      fill: "#fff",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M440.1,140.45a10.78,10.78,0,0,0-15-3.33l-16.5,10.75a12.08,12.08,0,0,0-1.21,5.28,11.84,11.84,0,0,0,11.7,12c.27,0,.55,0,.81,0l16.52-9.61A10.79,10.79,0,0,0,440.1,140.45Z",
    style: {
      fill: "#263238",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M366.5,171.5s-2.42,0-2.42,1.1-.64,5,.76,4.89,1.28-2.56,1.4-3.42S366.5,171.5,366.5,171.5Z",
    style: {
      fill: "#fff",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M369.14,167.52s-2.16-.67-2.66.66-1,7.65.5,7.48S368.81,169.85,369.14,167.52Z",
    style: {
      fill: "#fff",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M372.47,167.85s-2.5-2.16-3.33-.33-1,7,0,7,2.5-2.16,2.83-3.32A23,23,0,0,0,372.47,167.85Z",
    style: {
      fill: "#fff",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M376,168.85s-3.16-2.66-3.66-2.16-2.5,5.62-1,6.65,3.4-3.57,3.4-3.57Z",
    style: {
      fill: "#fff",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M330.33,184.63s.35,5.33,1.77,6.58a15.57,15.57,0,0,1,2.31,2.49,36.69,36.69,0,0,1,.36,4.09c0,1.6,1.07,1.42,2,1.42s2.49,3,3.38,4.44a24.74,24.74,0,0,0,6,5.34c1.6.89,4.27-2.49,4.27-2.49l1.24,3.56,12.63-8.18-6.22-12.1a29,29,0,0,0-3.74-11.91c-3.56-6.4-8.36-10-16.36-7.65S330.33,184.63,330.33,184.63Z",
    style: {
      fill: "#fff",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M344.94,160.93a29,29,0,0,0-8.73,1.75c-4.67,1.65-5.82,8.15-9.89,10.48s-2.33-2-4.37-.88-4.07,11.35.29,14.26,10.77-.87,10.77-.87-.58,2,1.16,2.62a29.94,29.94,0,0,0,3.21.87s-.3,3.5,2.32,3.2S340,188,340,188s4.95,9.6,8.74,10.77,9.31-4.08,10.76-6.41.29-18.91-2.91-25.31S344.94,160.93,344.94,160.93Z",
    style: {
      fill: "#263238",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M340.11,194.23s-1.78-6.76,1.06-5.87,4.45,6.94,4.27,7.65-1.6,1.06-2.31.89",
    style: {
      fill: "#fff",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M360.66,196.68a75,75,0,0,0-9.48,6.32c-3,2.67-5.69,10.67-5.69,10.67s18.32-12.45,21.52-14.22,3.91-2.67,3.91-2.67S364.22,195.79,360.66,196.68Z",
    style: {
      fill: "#fff",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M385.32,185.79a11.23,11.23,0,0,1,7.34-5.44c5.17-1.09,12,2.45,12.79,8.16s-3.54,8.44-6.26,8.44-5.17-3.81-5.17-3.81S385.32,189.87,385.32,185.79Z",
    style: {
      fill: "#fff",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M312.41,246.46l8.71-23.13a5.34,5.34,0,0,1-3.54,1.36c-2.18,0-7.34-.81-6-1.63s6.52-4.35,6.52-4.35-3.8.82-4.89,0-1.63-1.91-.82-2.18,2.45,0,5.44-1.09,4.35-2.17,6.8-2.17,4.63,4.35,4.63,5.71-1.91,27.2-1.91,28.29,0,2.18-7.07,3S312.14,249.45,312.41,246.46Z",
    style: {
      fill: "#fff",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 321.12,
    y1: 223.33,
    x2: 322.41,
    y2: 218.25,
    style: {
      fill: "#fff",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M320.84,240.74s-8.7,2.45-10.33,6.26-1.36,9.52,1.9,12.79,4.63,4.08,8.16,2.72,4.36-3.54,4.63-5.72S327.37,247.27,320.84,240.74Z",
    style: {
      fill: "#fff",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M317.31,356.09s-7.62-3.54-10.61-2.18-3,2.72.81,8.71,14.42,13.33,18,11.69.27-12.51.27-12.51Z",
    style: {
      fill: "#fff",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M311.87,364.52a42.35,42.35,0,0,1-6.6-9.75c-1.4,1.24-.8,3.06,2.24,7.85,3.81,6,14.42,13.33,18,11.69A3.24,3.24,0,0,0,327,371.6C322,373.71,316.83,370,311.87,364.52Z",
    style: {
      fill: "#fff",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M356.48,272.84l.27,8.17s-16.59,6.25-24.75,12-13.6,10.06-14.42,15.5-.27,47.61-.27,47.61-2.45.54-1.63,2.17,2.44,7.62,4.62,8.16,4.9,1.64,5.44.28,2.18-9.52,3.27-12.24S332,339,333.63,330a94.41,94.41,0,0,0,1.63-15.23,87.92,87.92,0,0,0,16.87-4.08c9.52-3.27,23.39-9.25,23.39-9.25s11.16,28,13.61,33.46,12,17.68,13.87,21.22,13.87,18.77,13.87,18.77,4.63-4.08,7.62-4.08h4.08s-4.9-13.6-9-21.77-12.51-21.49-12.51-21.49-7.61-47.59-7.89-50.87c-.53-6.28-4.55-15.76-4.55-15.76S381.51,258.15,356.48,272.84Z",
    style: {
      fill: "#263238",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M416.87,374.86a35.77,35.77,0,0,0-1.9,3.53c-.27.82-6.26,1.64-5.44,4.36s7.07,4.89,10.06,5.17,9-3.81,10.07-4.9c.64-.64,1.6-4.87,1.09-8.16a8.43,8.43,0,0,0-2.18-4.08S423.4,362.89,416.87,374.86Z",
    style: {
      fill: "#fff",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M430.75,374.86a8,8,0,0,0-1.85-3.72,8.31,8.31,0,0,0-6,2.63c-2.72,3.26-1.36,10.61-4.63,11.7-2.43.81-6.68-2.16-8.68-3.72a1.54,1.54,0,0,0,0,1c.81,2.72,7.07,4.89,10.06,5.17s9-3.81,10.07-4.9C430.3,382.38,431.26,378.15,430.75,374.86Z",
    style: {
      fill: "#fff",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M423.67,376.76c-1.08,4.9.28,8.16-4.08,11.16,3,.27,9-3.81,10.07-4.9.64-.64,1.6-4.87,1.09-8.16a6.42,6.42,0,0,0-.67-1.95l-.42,0S424.76,371.87,423.67,376.76Z",
    style: {
      fill: "#263238",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 378.24,
    y1: 300.86,
    x2: 394.29,
    y2: 292.98,
    style: {
      fill: "none",
      stroke: "#fff",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 385.59,
    y1: 297.33,
    x2: 399.46,
    y2: 295.42,
    style: {
      fill: "none",
      stroke: "#fff",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M391,183.89c-4.62.54-16.59,8.7-17.41,9.52s-4.08,2.72-5.44,3.81c0,0-28,17.41-30.47,19s-7.34,4.9-7.07,6-14.42,25-14.42,25-4.35,5.72-.27,10.88,7.89,1.64,9.79.55,16.87-15.24,16.87-15.24l13.8,33s19.11-12.81,39.52-12l-13.61-53.32s18.78-14.14,19.32-19S395.65,183.34,391,183.89Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("g", {
    style: {
      clipPath: "url(#freepik--clip-path--inject-3)"
    }
  }, /*#__PURE__*/React.createElement("path", {
    d: "M391,183.89c-1.85.22-4.88,1.66-7.91,3.36a3.58,3.58,0,0,1,3.65,1.52c2.25,2.89-2.57,12.2-2.57,12.2s-2-12.86-1.92-9-1,15.73-1,15.73-6.42-7.7-6.1-5.78,4.49,19.9,7.06,26.64-1.93,25.67-4.49,31.12-1-23.1-3.86-16-12.51,26.63-14.76,28.56.72-26.17,1.52-29.83c-1,3.06-7.61,22.45-7.61,22.45l-9-23.11s-15.4-12.51-13.8-10.27,5.46,9.31,5.46,9.31-9.31-1.93-7.7-1.28,8.66,4.17,8.66,4.17-14.44,10.27-18.61,11.55a16.74,16.74,0,0,1-3.44.63,8.18,8.18,0,0,0,1.29,2.32c4.08,5.17,7.89,1.64,9.79.55s16.87-15.24,16.87-15.24l13.8,33s19.11-12.81,39.52-12l-13.61-53.32s18.78-14.14,19.32-19S395.65,183.34,391,183.89Z",
    style: {
      fill: "#28BEA5"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M391,183.89c-1.85.22-4.88,1.66-7.91,3.36a3.58,3.58,0,0,1,3.65,1.52c2.25,2.89-2.57,12.2-2.57,12.2s-2-12.86-1.92-9-1,15.73-1,15.73-6.42-7.7-6.1-5.78,4.49,19.9,7.06,26.64-1.93,25.67-4.49,31.12-1-23.1-3.86-16-12.51,26.63-14.76,28.56.72-26.17,1.52-29.83c-1,3.06-7.61,22.45-7.61,22.45l-9-23.11s-15.4-12.51-13.8-10.27,5.46,9.31,5.46,9.31-9.31-1.93-7.7-1.28,8.66,4.17,8.66,4.17-14.44,10.27-18.61,11.55a16.74,16.74,0,0,1-3.44.63,8.18,8.18,0,0,0,1.29,2.32c4.08,5.17,7.89,1.64,9.79.55s16.87-15.24,16.87-15.24l13.8,33s19.11-12.81,39.52-12l-13.61-53.32s18.78-14.14,19.32-19S395.65,183.34,391,183.89Z",
    style: {
      fill: "#fff",
      opacity: 0.5
    }
  })), /*#__PURE__*/React.createElement("path", {
    d: "M391,183.89c-4.62.54-16.59,8.7-17.41,9.52s-4.08,2.72-5.44,3.81c0,0-28,17.41-30.47,19s-7.34,4.9-7.07,6-14.42,25-14.42,25-4.35,5.72-.27,10.88,7.89,1.64,9.79.55,16.87-15.24,16.87-15.24l13.8,33s19.11-12.81,39.52-12l-13.61-53.32s18.78-14.14,19.32-19S395.65,183.34,391,183.89Z",
    style: {
      fill: "none",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M356.41,276.41A71.61,71.61,0,0,1,357.56,254",
    style: {
      fill: "#fff",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M353.83,259.74s0-4.6,5.17-19",
    style: {
      fill: "#fff",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("polyline", {
    points: "332 231.5 342.61 243.46 331.73 235.57",
    style: {
      fill: "#fff",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("polyline", {
    points: "382.32 195.86 382.32 211.09 385.86 191.51",
    style: {
      fill: "#fff",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M360.78,242a2,2,0,0,0-.09.34C360.81,242,360.85,241.87,360.78,242Z",
    style: {
      fill: "#263238"
    }
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSatisfactionSurvey);
export default __webpack_public_path__ + "static/media/satisfaction-survey.a87ac53bd834c067b0b02ba6d139a33e.svg";
export { ForwardRef as ReactComponent };